import { FeedPageMinorSectionWithoutTitle, FeedPageMinorSectionWithTitle } from '../template.state.types';
import { LoadMoreAction, RECEIVED_POSTS_SUCCESSFULLY } from '../loadMore.actions';

export const AuthorPageSectionName = 'authorPageInfo' as const;

interface AuthorPageWithSection {
  [AuthorPageSectionName]: FeedPageMinorSectionWithTitle | FeedPageMinorSectionWithoutTitle;
}

export const authorPageReducer = (state: AuthorPageWithSection = {} as AuthorPageWithSection, action: LoadMoreAction<typeof AuthorPageSectionName>) => {
  // eslint-disable-next-line no-mixed-operators
  const oldArticles = state[AuthorPageSectionName] && state[AuthorPageSectionName].articles || [];
  switch (action.type) {
    case RECEIVED_POSTS_SUCCESSFULLY:
      return {
        ...state,
        [AuthorPageSectionName]: {
          ...state[AuthorPageSectionName],
          articles: [
            ...oldArticles,
            ...action.articles,
          ],
          showMorePaginationURL: action.next,
        },
      };

    default:
      return state;
  }
};
